module.exports = __webpack_public_path__ + "assets/d0d4f1cd56ebd5e07ed3b8e2d333d4bc.png";